<script>
  // insert position can be before_previews, between_previews, after_previews, filtered_previews
  import { slide } from 'svelte/transition'
  import { inserts_enabled } from '../stores'
  import TimesButton from '../elements/TimesButton.svelte'
  export let insert_position
  export let persistent = false

  let visibile = true
  
  const hide = () => { 
    $inserts_enabled = false 
    visibile = false
  }
</script>

{#if visibile}
  <div class="Insert {insert_position}" transition:slide|local>
    <div class="inner">
      {#if !persistent}
        <TimesButton on:click={hide}/>
      {/if}
      {#if $$slots.toptitle}
        <h4>
          <slot name="toptitle"></slot>
        </h4>
      {/if}
      <h2>
        <slot name="title"></slot>
      </h2>
      <p>
        <slot name="text"></slot>
      </p>
      {#if $$slots.button}
        <slot name="button"></slot>
      {/if}
    </div>
  </div>
{/if}

<style>
  .Insert {
    padding: 5rem 2rem 5rem 1rem;
    text-align: left;
    background-color: var(--c-bg);
    transition: background-color var(--transition-props);
  }

  .Insert h2 {
    font-family: var(--PensumDisplay);
    font-size: 5rem;
    line-height: 5.2rem;
    letter-spacing: 0.05rem;
    color: var(--c-text-big);
    transition: color var(--transition-props);
  }

  .Insert h4 {
    margin-top: -2.5rem;
    margin-bottom: 0.5rem;
    line-height: 2rem;
    color: var(--c-accent-orange);
    letter-spacing: 0.5px;
  }

  .Insert p {
    width: 64%;
    margin: 3rem 0 0 0.2rem;
    font-family: var(--PensumSans-Bold);
    font-size: 2.5rem;
    line-height: 3rem;
    color: var(--c-accent);
    font-variant-numeric: lining-nums;
  }

  .Insert :global(p span small) {
    display: block;
    width: 90%;
    margin-top: 3rem;
    font-size: 1.8rem;
    line-height: 1.4em;
    color: var(--c-text);
  }

  .Insert :global(span small) {
    display: inline;
  }

  .Insert.between_previews {
    padding: 8rem 1rem 8.5rem;
  }

  .Insert.after_previews {
    padding: 8rem 1rem 9rem;
  }

  .Insert.filtered_previews {
    padding: 6rem 2rem 6rem 2rem;
    text-align: center;
  }
  .Insert.filtered_previews h2 {
    font-size: 3.5rem;
    line-height: 3.6rem;
  }
  .Insert.filtered_previews p {
    font-size: 2.2rem;
    line-height: 2.6rem;
  }
  
  .Insert.filtered_previews p, 
  .Insert.filtered_previews :global(small) {
    margin-left: auto;
    margin-right: auto;
  }

  .Insert :global(.button) {
    margin-top: 1rem;
    margin-right: 1.5rem;
  }
</style>